import _ from 'lodash';
import { fieldValues } from './config';

export const KEYS = {
	ARROW_UP: 'ArrowUp',
	ARROW_DOWN: 'ArrowDown',
	UP: 'Up',
	DOWN: 'Down',
};

export const getFieldUnit = (fieldName, unit) => {
	const { units } = _.get(fieldValues, fieldName, fieldValues.default);

	return (unit && units[unit.toLowerCase()]) || '';
};

/**
 * CSS/HTML/JS Units of Measure Parsing
 * Regular Expressions (RegEx / RegExp) Pattern
 * Test http://www.regexr.com/39424
 * Pattern /(auto|none)|([-+]?\d*\.?\d+)\s?(px|em|rem|%|vw|vh+)?/i
 * @param value
 * @return {{string, number: Number, unit: string}}
 */
export const parseFieldValue = (fieldName, value) => {
	if (!value) {
		return null;
	}

	const { units, nonUnits } = _.get(fieldValues, fieldName, fieldValues.default);
	const nonUnitsGroup = _.filter(_.values(nonUnits), o => o !== '').join('|');
	const unitsGroup = _.filter(_.values(units), o => o !== '').join('|');

	if (nonUnitsGroup) {
		const valuePattern = `(${nonUnitsGroup})`;
		const valueRegex = new RegExp(valuePattern, 'i');
		const valueMatch = value.toString().match(valueRegex);

		if (valueMatch) {
			const [, v] = valueMatch;

			return { string: v, unit: '' };
		}
	}

	if (unitsGroup) {
		const unitPattern = `.*?(${unitsGroup}+)$`;
		const unitRegex = new RegExp(unitPattern, 'i');
		const unitMatch = value.toString().match(unitRegex);

		if (unitMatch) {
			const [, unit = ''] = unitMatch;
			const numberValue = value.substring(0, value.length - unit.length);

			return numberValue ? { number: numberValue, unit } : { number: '', unit }; // : null
		}
	}

	return { string: value, unit: '', invalid: _.isNaN(parseFloat(value)) };
};

export const hasValue = v => v !== '' && !_.isUndefined(v);

export const unitLabel = unit => unit || '—';

export const minMax = (value, min, max) => {
	if (hasValue(min) && value < min) {
		return min;
	}
	if (hasValue(max) && value > max) {
		return max;
	}
	return value;
};
